import { createSlice } from '@reduxjs/toolkit';

const environmentSlice = createSlice({
    name: 'env',
    initialState: {
        apiUrl: 'https://kazka-api-dev.azurewebsites.net/',
        token: ''
    },
    reducers: {
        changeTitle(state, action) {
            state.title = action.payload;
        },
        changeToken(state, action) {
            state.token = action.payload;
        }
    }
});

export const { changeToken } = environmentSlice.actions;
export const environmentReducer = environmentSlice.reducer;